import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Chip, ChipsList } from '@naf-simba/elements-chips';
import { findTopCategorySlug } from '@utils/createCategoryUrl';
import { Category } from '@appTypes/articleType';
import * as S from './ArticleTags.styles';

interface TagsListProps {
  tags: { name: string; slug: string }[];
  mappedCategories: { [key: string]: any };
  category: Category | null;
  articleUrl: string;
}

const ArticleTags: React.FC<TagsListProps> = ({ tags, mappedCategories, category, articleUrl }) => {
  const navigate = useNavigate();

  const handleTagClick = (chipUrl: string) => {
    navigate(chipUrl);
  };

  return (
    <S.TagsWrapper>
      <ChipsList>
        {tags.map((tag) => {
          const chipCategory = mappedCategories[tag.slug]?.data;
          let chipUrl = chipCategory?.url || articleUrl;

          if (chipCategory?.isGlobalTag && category) {
            const topCategorySlug = findTopCategorySlug(category);
            if (topCategorySlug) chipUrl = `/${topCategorySlug}/${chipCategory.slug}`;
          }

          return (
            <Chip
              key={`chip-${tag.name}`}
              label={tag.name}
              variant="outlined"
              color="primary"
              onClick={() => handleTagClick(chipUrl)}
            />
          );
        })}
      </ChipsList>
    </S.TagsWrapper>
  );
};

export default ArticleTags;
